import { Action } from '@ngrx/store';
import { PurchaseOrderAsyncErrors } from '@ordersnproducts/modules/order-builder/modules/location/models/purchase-order-async-errors';

export enum TopLocationPurchaseOrderActionTypes {
  SET_MASKS = '[Purchase order] Set valid mask formats',
  VALIDATE_START = '[Purchase order] Validate start',
  VALIDATE_END = '[Purchase order] Validate end',
  LOAD_INITIAL_STATE = '[Purchase order] load initial state',
  MANDATORY_PO = '[Purchase order] is needed',
  SET_PURCHASE_ORDER_ASYNC_ERRORS = '[Purchase Order] Set purchase order async errors',
  VALIDATION_ENDED = '[Purchase Order] Validation Ended',
}

export class PurchaseOrderLoadInitialState implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.LOAD_INITIAL_STATE;
  constructor(public payload: any) {}
}

export class PurchaseOrderMandatoryAction implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.MANDATORY_PO;
  constructor(public payload: boolean) {}
}

export class PurchaseOrderSetMasksAction implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.SET_MASKS;

  constructor(public payload: string[]) {}
}

export class PurchaseOrderValidateStartAction implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.VALIDATE_START;
  constructor() {}
}

export class PurchaseOrderValidateEndAction implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.VALIDATE_END;
  readonly payload: any;
  constructor() {}
}

export class SetPurchaseOrderAsyncErrorsAction implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.SET_PURCHASE_ORDER_ASYNC_ERRORS;
  constructor(public payload: PurchaseOrderAsyncErrors) {}
}

export class PurchaseOrderValidationEndedAction implements Action {
  readonly type = TopLocationPurchaseOrderActionTypes.VALIDATION_ENDED;
  constructor() {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type TopLocationPurchaseOrderActions =
  | PurchaseOrderSetMasksAction
  | PurchaseOrderMandatoryAction
  | PurchaseOrderLoadInitialState
  | PurchaseOrderValidateStartAction
  | PurchaseOrderValidateEndAction
  | SetPurchaseOrderAsyncErrorsAction
  | PurchaseOrderValidationEndedAction;
